import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { ProductIds, Roles } from "../constants";

function AuthGuard({ children, isPublic = false, role }) {
  const location = useLocation();
  const token = useSelector(
    (state) => state.auth.token || state.auth.guest_token || "",
  );
  const userRole = useSelector((state) => state.auth.role);
  console.log("🚀 ~ AuthGuard ~ userRole:", userRole);
  const navigate = useNavigate();

  const isValid = useMemo(() => {
    if (isPublic) {
      return true;
    }
    return !!token;
  }, [token, isPublic]);

  useEffect(() => {
    if (!token && !isPublic) {
      const intendedUrl = location.pathname + location.search;
      Cookies.set("intendedUrl", intendedUrl, { expires: 1 });
    }

    if (isValid) {
      if (role !== "all" && role !== userRole) {
        if (userRole === Roles.PATIENT) {
          navigate("/patient_dashboard");
        } else if (userRole === Roles.DENTIST) {
          navigate("/grind_guard");
        }
      }
    } else {
      if (token) {
        if (role !== "all" && role !== userRole) {
          if (userRole === Roles.PATIENT) {
            navigate("/patient_dashboard");
          } else if (userRole === Roles.DENTIST) {
            navigate("/grind_guard");
          }
        }
      } else {
        navigate("/");
      }
      console.log("You are in wrong way");
    }
  }, [
    isValid,
    isPublic,
    role,
    userRole,
    token,
    navigate,
    location.pathname,
    location.search,
  ]);

  return <>{isValid && children}</>;
}

export default AuthGuard;
